export abstract class AuditableEntity {
    Created: Date;
    CreatedBy: string;
    Modified: Date;
    ModifiedBy: string;
}